import React from "react";
import styled from "styled-components";

const logoPIH = require("../../assets/images/img_powerfly_logo.png");

const Logo = () => {
  return (
    <LogoWrapper>
      <ImgWrap src={logoPIH} alt="PIH_logo_icon" />
    </LogoWrapper>
  );
};

export default Logo;

const LogoWrapper = styled.div`
  height: auto;
  max-width: 100%;
`;
const ImgWrap = styled.img`
  width: 13rem;
`;
